const invoicesSummaryExport = (invoicesSummary, hoursDecimal, formatCurrency) => {
  const {
    total,
    accounts
  } = invoicesSummary.hours;
  const {
    totals
  } = invoicesSummary.invoice;
  const items = accounts.map(user => ({
    User: user.account.name,
    "Non-Billable": hoursDecimal(user.nonBillableHours),
    "Fixed Fee": hoursDecimal(user.fixedHours),
    Billable: hoursDecimal(user.billableHours),
    Amount: formatCurrency(user.amount)
  }));
  items.push({
    User: "Hours Total",
    "Non-Billable": hoursDecimal(total.nonBillableHours),
    "Fixed Fee": hoursDecimal(total.fixedHours),
    Billable: hoursDecimal(total.billableHours),
    Amount: formatCurrency(total.amount)
  });
  items.push(" ");
  items.push({
    User: "Fixed Fees Total",
    Amount: formatCurrency(totals.charges)
  });
  items.push({
    User: "Expenses",
    Amount: formatCurrency(totals.expenses)
  });
  if (totals.credit) {
    items.push({
      User: "Credits",
      Amount: formatCurrency(totals.credit)
    });
  }
  if (totals.taxComponents?.length) {
    totals.taxComponents.forEach(component => {
      items.push({
        User: component.name,
        Amount: formatCurrency(component.amount)
      });
    });
  } else if (totals.tax) {
    items.push({
      User: "Tax",
      Amount: formatCurrency(totals.tax)
    });
  }
  items.push({
    User: "Invoice Total",
    Amount: formatCurrency(totals.amount)
  });
  return items;
};
export default invoicesSummaryExport;